<template>
    <!-- 首页导航 -->
    <div class="header-menu-container full-screen-container">
        <div class="main-container flex-between menu-wrap">
            <ul class="menu-list flex-start">
                <li class="menu-item"
                    v-for="menuItem in navList"
                    :key="menuItem.id"
                    :class="[{'active': activeId && activeId === menuItem.id }, 'pointer']"
                    @click="changeMenu(menuItem, index)">
                    <span :title="menuItem?.title" >{{menuItem?.title}}</span>
                    <!-- 五个以内导航 -->
                    <ul
                        class="submenu-list pop-menu-list"
                        v-if="menuItem?.sub_navs?.length">
                        <li
                            class="pop-menu-item"
                            v-for="subItem in menuItem.sub_navs"
                            :key="subItem.id"
                            @click.stop="changeMenu(subItem)">
                           {{subItem.title}}
                        </li>
                    </ul>
                </li>
            </ul>
            <!-- 更多导航 -->
            <div class="flex-align">
                <!-- 更多导航 -->
                <div class="option-wrap flex-center pointer" @mouseenter="changeWidth" v-if="hasMore">
                    <span class="option-icon"></span>
                    <div class="more-menu-list" ref="menuRef" :class="{'menu-width' : menuWidth}">
                        <div
                            v-for="(item, index) in moreNavList"
                            :key="index"
                            class="mar-l40">
                            <div
                                class="pop-menu-header"
                                :class="[{'pointer title-hover': !item.sub_navs || item.sub_navs.length === 0 }]"
                                @click="changeMenu(item)">
                                {{item.title}}
                            </div>
                            <ul v-if="item.sub_navs">
                                <li
                                    class="more-menu-item pointer"
                                    v-for="(subItem, index) in item.sub_navs"
                                    :key="index"
                                    @click="changeMenu(subItem)">
                                    {{subItem.title}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="showAI" :class="['home-buddy', customClass]" @click="onJump()">
                    {{ customName }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { jumpHref } from '@/router/jumpHref.js';
import { useStore } from 'vuex';
import { pageJump } from '@/global/location-transfer';

const store = useStore();

const emit = defineEmits(['change-menu'])

const props = defineProps({
    menuList: { // 菜单
        type: Array,
        default: () => {
            return [];
        }
    },
    activeRoute: {
        type: Object,
        default: () => {
            return {};
        }
    }
})

const hasMore = ref(false)

// 当前选中的导航
const activeId = computed(() => {
    return props.activeRoute && props.activeRoute.id || '';
})


// 更多导航
const moreNavList = computed(() => {
    let menuList = props.menuList?.length ? props.menuList : [];
    menuList = menuList.filter(item => item.moduleKey !== 'toolkit');
    return menuList?.length && menuList || []
})

// 计算导航
const navList = computed(() => { // 西城不要工具
    let menuList = moreNavList.value.length && moreNavList.value || [];
    return calculateNavCount(menuList);
})

// 全部备案信息
const brand = computed(() => {
    return store.state.brand && store.state.brand.publishBrand ? store.state.brand.publishBrand : {};
})

const customClass = computed(() => {
    return ['scqjyxy'].includes(brand.value.brand) ? 'sc-buddy' : ''
})

const customName = computed(() => {
    return ['scqjyxy'].includes(brand.value.brand) ? '小尚伴学' : 'AI学伴'
})

let itemMarginRight = 80;
let firstMenuMargin = 70 + 45;

function calculateNavCount(menuList) {
    // 1082 = 1200 - 100 - 18
    let menuContainerMaxWidth = showAI.value ? 1082 : 1200;
    let menuLength = menuList.length;
    if(!menuList || menuLength == 0){
        return [];
    }
    let totalWidth = 0;
    let lastIndex = 0;
    let lastMenuWidth = 0;
    for (let index = 0; index < menuLength; index++) {
        let element = menuList[index];
        let itemWidth = getItemTitleLength(element.title || '');
        if(index == 0) {
            itemWidth = itemWidth + firstMenuMargin;
        }else if (index == menuLength - 1) { // 最后一个
            itemWidth = itemWidth + 35;
        }else {
            itemWidth = itemWidth + itemMarginRight;
        }
        lastMenuWidth = itemWidth;
        totalWidth += itemWidth;
        if(totalWidth === menuContainerMaxWidth) {  // 等于
            lastIndex = index;
            if(index < menuLength - 1) { 
                hasMore.value = true;
            }
            break;
        }
        if(totalWidth > menuContainerMaxWidth) { // 大于
            lastIndex = index;
            hasMore.value = true;
            break;
        }
        lastIndex = index;
    }
    if(hasMore.value) {
        if(totalWidth - lastMenuWidth > menuContainerMaxWidth - 50) {
            return menuList.slice(0, lastIndex - 1);
        }
        return menuList.slice(0, lastIndex);
    }
    return menuList.slice(0, lastIndex + 1);
}

const menuRef = ref(null);

const menuWidth = ref(false);

function changeWidth() {
    if(menuRef.value?.clientWidth >= 1200) {
        menuWidth.value = true;
    }else{
        menuWidth.value = false;
    }
}

// 
function getItemTitleLength(str) {
    return getTxtWidth(str, 18);
}

// 获得字符串字节长度
function getCharByte(str) {
    let char,
        cnCount = 0,
        enCount = 0,
        len = str.length;
    for(let i = 0; i < len; i++) {
        char = str.charAt(i);
        // eslint-disable-next-line no-control-regex
        if(/^[\u0000-\u00ff]$/.test(char)) { // 匹配双字节
            enCount += 1;
        } else {
            cnCount += 2;
        }
    }
    return {
        cn: cnCount,
        en: enCount
    };
}

// 获取字符串在屏幕的显示宽度
function getTxtWidth(str, fontSize) {
    if(str ==null || str == ''){
        return fontSize;
    }
    let obj = getCharByte(str);
    let cnBaseWidth = fontSize / 2;
    let enBaseWidth = fontSize * 0.57;
    return obj.cn * cnBaseWidth + obj.en * enBaseWidth;
}


// 跳转路由
function changeMenu (menuItem) {
    if(menuItem?.sub_navs?.length) {
        return;
    }
    emit('change-menu', menuItem.path);
}

const showAI = computed(() => { // 是否显示AI学伴
    let pagePermission = store.state?.pagePermission || {};
    let btnPermission = store.state?.user.btnPermission || []
    return !!pagePermission['ai:square'] && btnPermission.includes('siteFront:teacher_assistant');
})

// 学伴跳转
function onJump() {
    if ( ['scqjyxy'].includes(brand.value.brand) ) {
        pageJump(jumpHref.buddy.scIndex(), true)
    } else{
        pageJump(jumpHref.buddy.index(), true)
    }
}

</script>

<style lang="scss" scoped>

// 渐变色头部颜色
$nav-top-bg-color: var(--nav-top-bg-color);
// 渐变色底部颜色
$nav-bottom-bg-color: var(--nav-bottom-bg-color);

$nav-bg-active-color: var(--nav-bg-active-color);

$nav-sub-bg-active-color: var(--nav-sub-bg-active-color);
$nav-sub-bg-more-color: var(--nav-sub-bg-more-color);


.header-menu-container {
    height: 50px;
    background: linear-gradient(360deg, $nav-top-bg-color 0%, $nav-bottom-bg-color 100%);
    .menu-wrap {
        position: relative;
    }
    .menu-list {
        .menu-item {
            position: relative;
            height: 50px;
            color: var(--color-white);
            font-size: 18px;
            min-width: 60px;
            max-width: 250px;
            display: flex;
            align-items: center;
            text-align: center;
            overflow: visible;
            margin-right: 80px;
            flex-shrink: 0;
            span {
                // word-break: break-all;
                // text-overflow: ellipsis;
                // display: -webkit-box;
                -webkit-box-orient: vertical;
                // -webkit-line-clamp: 2; /* 这里是超出几行省略 */
                // overflow: hidden;
            }
            
            &:hover {
                font-weight: bold;
            }

            &.active {
                color: var(--color-white);
                padding: 0px 35px;
                background-color: $nav-bg-active-color;
                font-weight: bold;
                margin-right: 45px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            }

            &:hover {
                .pop-menu-list {
                    display: block;
                }
            }
        }
    }
    .submenu-list {
        padding: 20px;
    }
    .option-wrap {
        width: 50px;
        height: 50px;
        position: relative;
        background: rgba(0, 0, 0, 0.1);
        .option-icon {
            width: 22px;
            height: 22px;
            background-image: url(~@/assets/img/gateway/menu-stow@2x.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            transition: all 0.2s;
        }
        &:hover {
            .other-menu-list {
                display: flex;
            }
            .more-menu-list {
                 display: flex;
                 white-space: nowrap;
            }
            .option-icon {
                width: 18px;
                height: 18px;
                background-image: url(~@/assets/img/gateway/menu-open@2x.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }
        }
    }

    .more-menu-list, .pop-menu-list {
        position: absolute;
        background: $nav-sub-bg-more-color;
        border-radius: 4px;
        backdrop-filter: blur(6px);
        z-index: 3000;
        display: none;
        transition: display 0.2s;
        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: -2px;
            width: 100%;
            height: 2px;
            background: transparent;
            display: block;
        }
    }
    .more-menu-list {
        min-width: 152px;
        right: 0px;
        padding: 10px 5px 0px;
        top: 52px;
        &.menu-width {
            width: 1200px;
            justify-content: flex-end;
            flex-wrap: wrap;
        }
    }
    .pop-menu-list {
        width: 100%;
        min-width: 130px;
        top: 52px;
        left: 50%;
        transform: translateX(-50%);
        box-sizing: border-box;
    }
    .pop-menu-item,
    .more-menu-item {
        color: var(--color-white);
        cursor: pointer;
        &:hover {
            color: $nav-sub-bg-active-color;
        }
    }
    .pop-menu-item {
        font-size: 15px;
        line-height: 24px;
        text-align: center;
        &:nth-child(n+2) {
            margin: 13px 0 0;
        }
    }
    .more-menu-item {
        color: var(--color-white);
        line-height: 22px;
        text-align: center;
        margin: 12px 0 0;
        font-size: 14px;
    }
    .pop-menu-header {
        font-size: 15px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 24px;
        cursor: default;
    }
    .mar-l40 {
        padding: 10px 15px 20px 15px;
    }
}
.pointer {
    cursor: pointer !important;
}
.title-hover {
    &:hover {
        color: $nav-sub-bg-active-color;
    }
}

.flex-align {
    display: inline-flex;
    align-items: center;
}
.home-buddy {
    width: 100px;
    height: 28px;
    background: rgba(255,255,255,0.26);
    border: 1px solid rgba(255,255,255,0.5); 
    border-radius: 18px;
    font-size: 14px;
    color: #FFFFFF;
    text-align: right;
    padding-right: 10px;
    margin-right: 0px;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: 18px;
    &::before {
        content: '';
        background: url(~@/assets/img/home/buddy.png) no-repeat;
        width: 40px;
        height: 52px;
        background-size: contain;
        position: absolute;
        bottom: 0px;
        left: 6px;
    }
    &:hover {
        font-weight: bold;
        font-family: 'MicrosoftYaHei-Bold, MicrosoftYaHei';
    }
}
.sc-buddy {
    width: 110px;
    
    &::before {
        content: '';
        background: url(~@/assets/img/home/sc-buddy.png) no-repeat;
        width: 40px;
        height: 52px;
        background-size: contain;
        position: absolute;
        bottom: 0px;
        left: 6px;
    }
}

// .hs-buddy {
//     width: 110px;
    
//     &::before {
//         content: '';
//         background: url(~@/assets/img/buddy/hanshan-buddy.png) no-repeat;
//         width: 40px;
//         height: 52px;
//         background-size: contain;
//         position: absolute;
//         bottom: 0px;
//         left: 6px;
//     }
// }
</style>
